export default function isLayerTypeAuthorized(type: LayerType, user: User | undefined) {
    if (type.subscription_dataset === 'gaiagreen') {
        return !user || user.hasPremiumSubscription;
    } else {
        return true;
    }
}
